module.exports = __webpack_public_path__ + "img/wait_orange.18210887.svg";